// Menus for My Videos. View items are built at render time so the current view carries the dot.
export const File = [
  { type: 'item', text: 'Play all' },
  { type: 'item', text: 'Full screen' },
  { type: 'separator' },
  { type: 'item', text: 'Rename', disable: true },
  { type: 'item', text: 'Properties', disable: true },
  { type: 'separator' },
  { type: 'item', text: 'Close' },
];

export const viewMenu = view => [
  { type: 'item', text: 'Filmstrip', symbol: view === 'filmstrip' ? 'circle' : undefined },
  { type: 'item', text: 'Thumbnails', symbol: view === 'thumbs' ? 'circle' : undefined },
  { type: 'item', text: 'Tiles', disable: true },
  { type: 'item', text: 'Icons', disable: true },
  { type: 'item', text: 'List', disable: true },
  { type: 'item', text: 'Details', disable: true },
  { type: 'separator' },
  { type: 'item', text: 'Refresh' },
];

export const Help = [
  { type: 'item', text: 'About My Videos' },
];
